import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class FilterUsersService {

  private _filterColumns = 'api/User/FilterColumns';
  private _filterUsers = 'api/User';

  constructor(private _restApi: RestApi) { }

  public getFilterColumns() {
    return this._restApi.get(this._filterColumns).toPromise();
  }

  public filterUsers(filterColumn: string, valueToSearch: string): Observable<ISpecificUser[]>{
    return this._restApi.get(`${this._filterUsers}/${filterColumn}/${valueToSearch}`);
  }
}
